<template>
  <span>
    <slot></slot>
  </span>
</template>

<script>
export default {};
</script>

<style scoped>
span {
  color: green;
  -webkit-animation: glow 1s ease-in-out infinite alternate;
  -moz-animation: glow 1s ease-in-out infinite alternate;
  animation: glow 1s ease-in-out infinite alternate;
}
</style>
